import React from 'react'
import { Navigate } from 'react-router-dom'
import useLogin from '../../redux/hooks/useLogin'

const Public = ({ children }) => {
  const { user, token, sessionType } = useLogin()
  const campaignToken = sessionStorage.getItem('campaignToken')
  if (user && [0, 7, 6].includes(user.status) && sessionType === 'USER') {
    const redirectTo = campaignToken ? '/auth/register-save-campaign' : '/auth/register-save'
    return <Navigate to={redirectTo} state={{ data: user }} />
  }
  else if (token && sessionType === 'USER') return <Navigate to="/perfil/inicio" />

  return children
}

export default Public
